import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTwitterComponent } from './simple-icons-twitter.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTwitterComponent ],
    exports:      [ SimpleIconsTwitterComponent ],
    bootstrap:    []
})
export class SimpleIconsTwitterModule {}
